import { render, staticRenderFns } from "./hotelHeader.vue?vue&type=template&id=6aed2a75&scoped=true&"
import script from "./hotelHeader.vue?vue&type=script&lang=ts&"
export * from "./hotelHeader.vue?vue&type=script&lang=ts&"
import style0 from "./hotelHeader.vue?vue&type=style&index=0&id=6aed2a75&lang=scss&scoped=true&"
import style1 from "./hotelHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aed2a75",
  null
  
)

export default component.exports